import React from 'react';
import { StarIcon, CheckIcon } from 'lucide-react';
export function PricingCards() {
  const contents = [{
    title: '6 Módulos Premium sobre Perfiles Cognitivos Infantiles con Enfoque Wechsler',
    value: '$122.500'
  }, {
    title: 'Material listo para intervenir, registrar, informar y hacer seguimiento del caso',
    value: '$84.950'
  }, {
    title: '6 Bonos Estratégicos para complementar la práctica profesional',
    value: '$90.000'
  }];
  return <section id="ofertas" className="w-full bg-transparent py-8" data-id="element-143">
      <div className="max-w-4xl mx-auto px-4 md:px-6" data-id="element-144">
        <div className="text-center mb-6" data-id="element-145">
          <h2 className="md:text-3xl text-[14px] font-[800] font-[Montserrat,_sans-serif] text-[#FFFFFF]" data-id="element-146">
            Menos improvisación. Más claridad, más recursos listos y una
            práctica mucho más profesional.
          </h2>
        </div>

        <div className="max-w-md mx-auto" data-id="element-147">
          {/* Premium */}
          <div id="oferta-pro" className="relative scroll-mt-24 bg-[#141414] border-2 border-[#C084FC]/50 rounded-2xl p-5 flex flex-col justify-between shadow-[0_0_30px_rgba(192,132,252,0.12)]" data-id="element-148">
            <div className="absolute -top-3 left-1/2 transform -translate-x-1/2" data-id="element-149">
              <div className="bg-[#C084FC] text-white px-4 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider flex items-center gap-1.5 shadow-[0_0_12px_rgba(192,132,252,0.4)]" data-id="element-150">
                <StarIcon className="w-3 h-3 fill-current" data-id="element-151" />
                La más elegida
              </div>
            </div>

            <div data-id="element-152">
              <p className="text-[10px] uppercase tracking-[0.25em] text-[#D8B4FE] font-bold mb-3 mt-3 text-center" data-id="element-153">
                Contenidos del MegaPack
              </p>

              {/* Content list with values */}
              <ul className="mb-5 divide-y divide-white/[0.06]" data-id="element-154">
                {contents.map((item, i) => <li key={i} className="flex items-start gap-3 py-3 first:pt-1" data-id="element-155">
                    <CheckIcon className="w-4 h-4 text-[#C084FC] flex-shrink-0 mt-0.5" strokeWidth={3} data-id="element-156" />
                    <div className="flex-1 min-w-0 flex items-start justify-between gap-3" data-id="element-157">
                      <p className="text-[13px] md:text-sm text-gray-200 leading-snug" data-id="element-158">
                        {item.title}
                      </p>
                      <span className="text-[12px] md:text-[13px] text-[#D8B4FE] font-bold whitespace-nowrap" data-id="element-159">
                        {item.value}
                      </span>
                    </div>
                  </li>)}
              </ul>

              {/* Total value */}
              <div className="rounded-xl border border-white/[0.08] bg-[#0F0F0F] px-4 py-3 mb-3 flex items-center justify-between" data-id="element-160">
                <span className="text-[11px] md:text-xs uppercase tracking-[0.2em] text-gray-400 font-bold" data-id="element-161">
                  Valor total
                </span>
                <span className="text-gray-300 line-through text-lg md:text-xl font-[900]" data-id="element-162">
                  $297.450
                </span>
              </div>

              {/* Price today */}
              <div className="rounded-xl border border-[#C084FC]/40 bg-gradient-to-br from-[#C084FC]/15 via-[#1A1A1A] to-[#1A1A1A] px-4 py-4 mb-5 text-center" data-id="element-163">
                <p className="text-[10px] uppercase tracking-[0.25em] text-[#D8B4FE] font-bold mb-1" data-id="element-164">
                  Precio hoy
                </p>
                <p className="text-[#C084FC] text-4xl md:text-5xl font-[900] leading-none" data-id="element-165">
                  🏆$27.990
                </p>
              </div>
            </div>

            <a href="https://salud-en-tu-plato.myshopify.com/checkouts/cn/hWNB4E9meKkYhBMy6fUynNf0/es-ar?_r=AQABo78Q9twD-D_E4sl-tKmHuDKGH8R9WZS18sN02eg9Ya0&cart_link_id=5PQZWMuB&preview_theme_id=151828791463" target="_blank" rel="noopener noreferrer" className="block w-full bg-[#C084FC] hover:bg-[#9333EA] text-white text-center px-4 py-3 rounded-xl transition-all duration-200 hover:scale-[1.02] shadow-[0_0_15px_rgba(192,132,252,0.3)] text-[20px] font-[900] font-['Open_Sans',_sans-serif]" data-id="element-166">
              SI! QUIERO LA OFERTA💥
            </a>
          </div>
        </div>
      </div>
    </section>;
}